<template>
  <div class="start-screen">
    <a :href="quizRulesUrl" class="instructions-link" target="_blank">
      <svg width="17" height="17" viewBox="0 0 17 17">
        <path
          d="M14.514 2.493A8.5 8.5 0 1 0 2.486 14.507 8.5 8.5 0 0 0 14.514 2.493m-4.827 11.4a.237.237 0 0 1-.238.238H7.551a.237.237 0 0 1-.238-.237v-7.05c0-.13.107-.237.238-.237h1.898c.132 0 .238.106.238.238zM8.5 5.624a1.38 1.38 0 0 1-1.377-1.377c0-.76.618-1.377 1.377-1.377.76 0 1.377.618 1.377 1.377S9.259 5.622 8.5 5.622"
        />
      </svg>
      How to Play</a
    >
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="69"
        viewBox="0 0 56 69"
        class="bulb"
      >
        <path
          d="M34.529 57.945H21.157a2.227 2.227 0 0 0-2.229 2.229c0 1.231.997 2.228 2.229 2.228h13.372a2.227 2.227 0 0 0 2.228-2.228 2.227 2.227 0 0 0-2.228-2.229ZM9.38 13.341l-2.056-1.189a2.227 2.227 0 0 0-3.045.816l-1.1 1.908a2.232 2.232 0 0 0 .818 3.044l2.042 1.178c.331.191.704.292 1.078.292.803 0 1.539-.456 1.919-1.191.316-.611.671-1.22 1.055-1.81a2.166 2.166 0 0 0 .304-1.698 2.116 2.116 0 0 0-1.014-1.35ZM26.863 6.73c.29-.037.634-.075.98-.075.345 0 .688.038.978.075.093.011.186.017.278.017 1.161 0 2.071-.92 2.071-2.095V2.23c0-1.23-1-2.229-2.229-2.229h-2.197c-1.23 0-2.229 1-2.229 2.229v2.423c0 1.175.91 2.095 2.071 2.095.092 0 .186-.006.277-.017ZM15.184 10.454c.424 0 .84-.126 1.205-.363.59-.384 1.198-.738 1.81-1.055a2.178 2.178 0 0 0 1.105-1.326 2.122 2.122 0 0 0-.206-1.67L17.92 3.996a2.235 2.235 0 0 0-1.932-1.116c-.39 0-.774.103-1.113.298l-1.907 1.1a2.213 2.213 0 0 0-1.04 1.353 2.213 2.213 0 0 0 .224 1.691L13.34 9.38a2.112 2.112 0 0 0 1.843 1.074ZM51.406 12.968a2.229 2.229 0 0 0-3.045-.816l-2.057 1.19c-.518.299-.878.778-1.015 1.349-.138.58-.03 1.184.306 1.699.386.592.742 1.2 1.058 1.81a2.166 2.166 0 0 0 1.919 1.19c.374 0 .747-.102 1.078-.293l2.039-1.177a2.232 2.232 0 0 0 .816-3.045l-1.099-1.907ZM37.49 9.036c.612.317 1.22.671 1.806 1.052.364.236.78.361 1.204.361.766 0 1.455-.401 1.844-1.073l1.185-2.052a2.232 2.232 0 0 0-.815-3.046l-1.9-1.097a2.229 2.229 0 0 0-3.044.815L36.59 6.04a2.126 2.126 0 0 0-.207 1.672c.169.573.56 1.043 1.106 1.325ZM0 26.744v2.198c0 1.229 1 2.229 2.229 2.229h2.432c.613 0 1.189-.255 1.58-.699.389-.444.568-1.046.49-1.652a7.806 7.806 0 0 1-.076-.977c0-.345.038-.688.074-.978a2.092 2.092 0 0 0-.493-1.649c-.392-.445-.97-.7-1.584-.7H2.23A2.23 2.23 0 0 0 0 26.744ZM55.685 28.941v-2.197c0-1.23-1-2.23-2.229-2.23h-2.423c-.614 0-1.191.256-1.584.7a2.092 2.092 0 0 0-.493 1.65c.036.29.074.633.074.978 0 .348-.04.705-.075.976-.079.607.1 1.209.49 1.652.39.444.966.7 1.579.7h2.432a2.23 2.23 0 0 0 2.23-2.229ZM51.688 37.766l-2.09-1.205a2.134 2.134 0 0 0-1.064-.29c-.825 0-1.575.507-1.909 1.29-.28.658-.581 1.328-.89 1.99a2.34 2.34 0 0 0 .936 3.002l1.69.976a2.226 2.226 0 0 0 3.045-.816l1.1-1.903a2.214 2.214 0 0 0 .221-1.692 2.212 2.212 0 0 0-1.04-1.352ZM7.132 36.28c-.366 0-.734.1-1.062.29l-2.073 1.195a2.214 2.214 0 0 0-1.04 1.353 2.214 2.214 0 0 0 .223 1.692l1.099 1.904a2.228 2.228 0 0 0 3.045.817l1.659-.957a2.345 2.345 0 0 0 .942-3 62.225 62.225 0 0 1-.886-2c-.331-.785-1.08-1.294-1.907-1.294ZM34.849 66.778a2.22 2.22 0 0 0-2.223-2.223H23.06a2.221 2.221 0 0 0-2.222 2.223A2.22 2.22 0 0 0 23.059 69h9.568a2.22 2.22 0 0 0 2.222-2.222ZM13.514 41.432c2.034 4.086 3.956 7.944 4.271 11.74.1 1.198 1.098 2.136 2.273 2.136h15.57c1.178 0 2.175-.94 2.27-2.141.31-3.943 2.352-8.009 4.325-11.94 2.236-4.455 4.548-9.061 4.548-13.761 0-10.437-8.491-18.928-18.928-18.928-10.437 0-18.928 8.49-18.928 18.928 0 4.733 2.338 9.427 4.599 13.966Zm14.329-26.239c6.767 0 12.272 5.506 12.272 12.273 0 3.121-1.86 6.832-3.831 10.76l-.009.016c-1.616 3.214-3.289 6.538-4.257 10.127-.038.141-.229.284-.338.284h-7.696c-.112 0-.308-.146-.348-.29-.958-3.46-2.59-6.732-4.169-9.896-2.007-4.035-3.897-7.837-3.897-11.001 0-6.768 5.506-12.273 12.273-12.273Z"
        />
      </svg>
      <h2 v-if="quizData.intro_heading" class="slate-graf intro-heading">
        {{ quizData.intro_heading }}
      </h2>
      <div
        v-if="quizData.intro_paragraph"
        class="slate-graf"
        v-html="quizData.intro_paragraph"
      ></div>
    </div>

    <div class="match-up" v-if="quizData.slatester_name">
      <div class="match-up-avatars">
        <Avatar
          :name="username || 'You'"
          :title="userLabel || 'Slate Reader'"
          :gus="userHasGus"
          :image="slateReaderImg"
        />
        <p class="match-up-versus"><b>vs.</b></p>
        <Avatar
          :name="quizData.slatester_name"
          :title="quizData.slatester_title"
          :image="quizData.slatester_image"
        />
      </div>
    </div>

    <StreakStatus :username="username"></StreakStatus>

    <div class="btn-group">
      <a
        v-if="!username"
        :href="loginUrl"
        @click="redirectBack"
        target="_top"
        class="slate-btn--juicy secondary"
      >
        Sign in / create account
      </a>
      <button
        class="slate-btn--juicy start-btn"
        @click.prevent="emit('advance')"
      >
        <svg
          width="36"
          :height="ICON_SIZE"
          viewBox="0 0 36 35"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 0.5C8.33504 0.5 0.5 8.11119 0.5 17.5C0.5 26.8888 8.33504 34.5 18 34.5C27.665 34.5 35.5 26.8888 35.5 17.5C35.5 8.11119 27.665 0.5 18 0.5ZM24.1606 18.2519L15.6383 23.8878C15.3515 24.0774 14.9802 24.0975 14.6736 23.9399C14.3669 23.7823 14.175 23.4729 14.175 23.1359V11.8641C14.175 11.5271 14.3669 11.2177 14.6736 11.0601C14.9802 10.9025 15.3515 10.9225 15.6383 11.1122L24.1606 16.7481C24.4167 16.9175 24.5701 17.199 24.5701 17.5C24.5701 17.801 24.4168 18.0825 24.1606 18.2519Z"
          />
        </svg>
        Start the quiz
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import Avatar from "@/components/Avatar.vue";
import StreakStatus from "@/components/StreakStatus.vue";
import slateReaderImg from "@/assets/slate_reader.png";
import { redirectBack } from "@/utils";

const ICON_SIZE = 35;
const ICON_SIZE_STR = `${ICON_SIZE}px`;

const props = defineProps({
  username: { type: String, default: "" },
  userLabel: { type: String, default: "Slate Reader", required: true },
  userHasGus: { type: Boolean, required: true },
  quizData: { type: Object, required: true },
});

const emit = defineEmits(["advance"]);

let loginUrl = `${import.meta.env.VITE_SLATE_DOMAIN}/sign-in`;
let quizRulesUrl = `${import.meta.env.VITE_SLATE_DOMAIN}/slate-news-quiz-rules`;
</script>

<style scoped lang="scss">
@import "../styles/when-dark-mode.scss";
.start-screen {
  padding: 2em;
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-block-sm);
  align-items: center;
  justify-content: center;
  font-size: var(--font-grow-1);
  text-align: center;
}

@mixin instructions-link-dark() {
  color: var(--gray-f0-color);
  fill: currentColor;
  opacity: 0.9;
  &:hover,
  &:focus-visible {
    opacity: 1;
  }
}

.instructions-link {
  border: none;
  color: #666;
  display: flex;
  font-size: var(--font-shrink-4);
  font-weight: bold;
  gap: 0.4em;
  justify-content: center;
  position: absolute;
  right: 0.7em;
  text-decoration: none;
  transition: 0.15s ease-in-out;
  transition-property: opacity;
  top: 0.5em;
  padding: var(--spacing-block-xs) var(--spacing-block-sm);

  & svg {
    fill: #999;
    height: 1.1em;
    vertical-align: top;

    @include when-dark-mode {
      @include instructions-link-dark;
    }
  }

  @include when-dark-mode {
    @include instructions-link-dark;
  }
}

.bulb {
  display: block;
  fill: var(--gray-c-color);
  margin: 1.1rem auto;
}

.intro-heading {
  font-size: var(--font-grow-6);
}

.match-up {
  margin: 0 0 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.match-up-avatars {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--interactive-border-color);
  padding: 0 1rem;
  border-radius: 4px;
}

.match-up-avatars > b {
  margin: 0 1.5em;
}

.match-up-versus {
  text-align: center;
  margin: 0 1.5em;
}

.btn-group {
  color: var(--gray-2-color);
  display: inline-flex;
  flex-wrap: wrap;
  gap: var(--spacing-block-sm);
  justify-content: center;
}

.btn-group * {
  color: inherit;
}

.slate-btn--juicy {
  /* Clementine */
  --btn-hue: 39deg;
  --btn-saturation: 100%;
  --btn-lightness: 53%;
}

.secondary {
  --btn-hue: 0;
  --btn-saturation: 0%;
  --btn-lightness: 85.1%;
}

/* empty/placeholder svg to get the sizes to match up just right */
.slate-btn--juicy:not(:has(svg)) {
  box-sizing: content-box;
  min-height: v-bind(ICON_SIZE_STR);
  line-height: v-bind(ICON_SIZE_STR);
}

svg {
  height: auto;
  width: auto;
  max-height: v-bind(ICON_SIZE_STR);
}

/* there's probably some magical css way to do this but i just picked a nice safe size */
/* this did not quite work https://heydonworks.com/article/the-flexbox-holy-albatross/ */
@media (max-width: 30em) {
  .match-up-avatars {
    flex-direction: column;
    align-items: flex-start;
  }

  .match-up-versus {
    width: 100%;
  }
}
</style>
